import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import * as HttpStatusCodes from '../../common/httpStatusCodes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {fetchInvoiceLinesCheckStatus} from './common';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const showErrorMessageIfBoxIsNotBelongInvoice = (response) => {
  if (response.data.isInInvoice) {
    return {
      'type': ActionTypes.SUCCESS_BOX_MEMBERSHIP_CHECK,
    };
  }

  const error = {
    'data': {
      'type': 'La caja no pertenece a la factura',
      'code': HttpStatusCodes.HTTP_400_BAD_REQUEST,
    },
  };
  return buildErrorMessage(error);
};

export const showErrorMessageIfStorageCarCloseAutomatically = (response) => {
  if (!response.data.filledStorageCar) {
    return {
      'type': ActionTypes.STORAGE_CAR_STILL_AVAILABLE,
    };
  }
  return MessageActions.addMessageBoxInfo(
    `El coche ${response.data.storageCar} llegó a su máxima capacidad y ha sido cerrado automáticamente`
  );
};

export const fetchBoxesByInvoice = (invoice) => apiActionCreator({
  'endpoint': `/checkProcesses/invoices/${invoice}/boxes`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_BOXES_LIST_BY_INVOICE,
    ActionTypes.FETCHED_BOXES_LIST_BY_INVOICE,
    [
      ActionTypes.FETCHED_BOXES_LIST_BY_INVOICE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const validateBoxBelongInvoice = (invoice, box, index) => apiActionCreator({
  'endpoint': `/checkProcesses/invoices/${invoice}/boxes/${box}/verification?action=check`,
  'authenticated': true,
  'types': [
    ActionTypes.VALIDATING_BOX_BELONG_INVOICE,
    [
      {
        'type': ActionTypes.VALIDATED_BOX_BELONG_INVOICE,
        'payload': {index, box},
      },
      (response) => showErrorMessageIfBoxIsNotBelongInvoice(response),
    ],
    [
      ActionTypes.VALIDATED_BOX_BELONG_INVOICE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const verifyInvoiceLineInfo = ({invoice, box, partCode}, index) => apiActionCreator({
  'endpoint': `/checkProcesses/invoices/${invoice}/boxes/${box}/parts/${partCode}`,
  'authenticated': true,
  'types': [
    ActionTypes.VERIFYING_INVOICE_LINE_INFO,
    {
      'type': ActionTypes.VERIFIED_INVOICE_LINE_INFO,
      'payload': index,
    },
    [
      {
        'type': ActionTypes.VERIFIED_INVOICE_LINE_INFO_FAILED,
        'payload': index,
      },
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveInvoiceLineInfo = ({invoice, box, partCode}, index, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/checkProcesses/invoices/${invoice}/boxes/${box}/parts/${partCode}`,
      'authenticated': true,
      'types': [
        ActionTypes.SAVING_INVOICE_LINE_INFO,
        [
          () => {
            dispatch(fetchInvoiceLinesCheckStatus(invoice));
            return {
              'type': ActionTypes.SAVED_INVOICE_LINE_INFO,
              'payload': index,
            };
          },
          (response) => showErrorMessageIfStorageCarCloseAutomatically(response),
        ],
        [
          {
            'type': ActionTypes.SAVED_INVOICE_LINE_INFO_FAILED,
            'payload': data.storageCar,
          },
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    }),
  );
};

export const clearItems = () => ({
  'type': ActionTypes.CLEAR_ITEMS,
});

export const setLastCheckedBox = (index, lastCheckedBox) => ({
  'type': ActionTypes.SET_LAST_CHECKED_BOX,
  'payload': {index, lastCheckedBox},
});

export const updateBinningFields = (index, fieldsToUpdate) => ({
  'type': ActionTypes.UPDATE_FIELDS_BINNING,
  'payload': {index, fieldsToUpdate},
});
